import React from 'react';
import ReactMapGL, { Marker } from 'react-map-gl';
import { Tooltip } from 'antd';

import swindledPin from './swindled.json';
import morbidPin from './morbid.json';
import crimejunkiePin from './crimejunkie.json';

const TOKEN = 'pk.eyJ1Ijoic2xhdzMiLCJhIjoiY2tocDAwdGFnMDM0dDJ5bWhwemJ0cWxtcSJ9.2yHmRxoDsgeVqJkFSmhn_g';

function Pin ({ latitude, longitude, size, color, tooltipName, onClick }) {
  return (
    <Marker
      latitude={latitude}
      longitude={longitude} >
      <Tooltip
        placement='rightTop'
        title={tooltipName} >
        <svg
          className='marker'
          height={size}
          viewBox='0 0 100 100'
          style={{fill: color, cursor: 'pointer', transform: `translate(${-size / 2}px,${-size}px)` }}
          onClick={onClick} >
          <circle cx="50" cy="50" r="50" />
        </svg>
      </Tooltip>
    </Marker>
  )
};

function UserPin({ userLoc }) {
  const { latitude = null, longitude = null, showLoc } = userLoc;

  return (
    showLoc && <Pin
      latitude={latitude}
      longitude={longitude}
      size={10}
      color='#520396'
      tooltipName='Your location'
    />
  )
};

function EpisodePin({ podcast, setCardData, setShowCard, setViewport, viewport }) {
  return (
    React.useMemo(() => podcast.map(({ title, URL, crime_year, description, city, lat, long, wiki }) => {
      const handleClick = () => {
        setCardData({
          title: title,
          link: URL,
          year: crime_year,
          description: description,
          city: city,
          wiki: wiki,
        });
        setShowCard(true);
      };
      return (
        (lat && long) && <Pin 
        latitude={lat}
        longitude={long}
        size={10}
        color='#ff3d3d'
        tooltipName={title}
        onClick={handleClick}
        key={title}
        />
      )
    }), [])
  )};

function Map ({ swindled, crimejunkie, morbid, redhanded, setCardData, setShowCard, userLoc }) {
  const fillscreen = {
    width: '100vw',
    height: '100vh',
  }

  const [viewport, setViewport] = React.useState({
    latitude: 39.828175,
    longitude: -98.5795,
    zoom: 4,
    ...fillscreen,
  });

  return (
    <React.Fragment>
      <ReactMapGL
        {...viewport}
        mapboxApiAccessToken={TOKEN}
        onViewportChange={nextViewport => setViewport({ ...nextViewport, ...fillscreen })}
        onResize={() => setViewport({...viewport, ...fillscreen })}
      >
        {morbid && <EpisodePin podcast={morbidPin} setCardData={setCardData} setShowCard={setShowCard} />}
        {crimejunkie && <EpisodePin podcast={crimejunkiePin} setCardData={setCardData} setShowCard={setShowCard} setViewport={setViewport} viewport={viewport} />}
        {swindled && <EpisodePin podcast={swindledPin} setCardData={setCardData} setShowCard={setShowCard} />}
        <UserPin userLoc={userLoc} />
      </ReactMapGL>
    </React.Fragment>
  );
}

export default Map;